import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { API_DICTIONARY } from 'api/endpoints';
import XHR from './i18n-backend';
import { APP_CONFIG } from 'appConfig';

export function initI18n(config: { cs?: any; en?: any }) {
  i18n
    .use(XHR)
    .use(initReactI18next)
    .init({
      debug: APP_CONFIG.uiI18nDebug,
      backend: {
        loadPath: `${APP_CONFIG.apiUrl}/${APP_CONFIG.apiVersion}${API_DICTIONARY}`,
        localResources: {
          cs: config.cs,
          en: config.en,
        },
      },
      lng: 'cs',
      fallbackLng: 'cs',

      keySeparator: false,

      interpolation: {
        escapeValue: false,
      },
      react: {
        useSuspense: true,
      },
    });
}
